import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

const splitTrialMessage = (message) => {
    const text = String(message || '').trim();
    const match = text.match(/^(.*?)(\d+\s*Days?)$/i);
    if (!match) return { prefix: text, days: '' };
    return { prefix: match[1], days: match[2] };
};

const openPaymentLink = async (url) => {
    if (!url) return;
    if (Capacitor.isNativePlatform()) {
        await Browser.open({ url });
        return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
};

const TrialAdmissionBanner = ({ message, buttonTitle, paymentLink }) => {
    const { prefix, days } = splitTrialMessage(message);
    const title = buttonTitle || 'Confirm your seat';

    return (
        <div className="flex items-center gap-3 rounded-[20px] border border-[#FDE1CD] bg-[#FFF4E8] p-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#FF7426] shadow-md">
                <svg viewBox="0 0 24 24" className="h-6 w-6 text-white" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M5 22h14" />
                    <path d="M5 2h14" />
                    <path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22" />
                    <path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" />
                </svg>
            </div>
            <div className="flex min-w-0 flex-1 flex-col md:flex-row md:items-center md:justify-between md:gap-4">
                <div className="min-w-0">
                    <p className="text-xs font-semibold text-[#FF7426]">Trial Admission</p>
                    <p className="mt-0.5 text-[15px] font-bold leading-snug text-[#0F172A]">
                        {prefix}
                        {days ? <span className="text-[#FF7426]">{days}</span> : null}
                    </p>
                </div>
                {paymentLink ? (
                    <button
                        type="button"
                        onClick={() => openPaymentLink(paymentLink)}
                        className="mt-2 inline-flex w-fit shrink-0 items-center gap-0.5 rounded-full bg-[#00A5CF] px-3.5 py-1.5 text-sm font-semibold text-white active:scale-[0.98] md:mt-0"
                    >
                        {title}
                        <ChevronRight className="h-4 w-4" />
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default TrialAdmissionBanner;
